import { Center, Text } from '@mantine/core';
import { HiOutlineRectangleStack } from 'react-icons/hi2';
import AppIcon from '@/components/AppIcon.tsx';
import React, { useEffect } from 'react';
import useLatestAutomationRun from '@/hooks/api/runs/useLatestAutomationRun.ts';
import { useNavigate } from 'react-router-dom';
import CustomSpinner from '@/components/Spinner.tsx';
import { useAutomation } from '@/context/AutomationContext/useAutomationContext.ts';

const RunPageEmpty = () => {
  const automation = useAutomation();
  const shouldFetchLatestRun = !automation.latest_run_id && automation.run_count > 0;
  const { latestRun, isLoading } = useLatestAutomationRun({ enabled: shouldFetchLatestRun });
  const navigate = useNavigate();

  useEffect(() => {
    const latestRunId = automation.latest_run_id || latestRun?.id;
    if (latestRunId) {
      navigate(`/automations/${automation.id}/runs/${latestRunId}`, { replace: true });
    }
  }, [automation.id, automation.latest_run_id, latestRun?.id, navigate]);

  if (isLoading) {
    return <CustomSpinner />;
  }

  return (
    <Center w="100%" h="100%" style={{ flexDirection: 'column' }} pb="50px">
      <AppIcon Icon={HiOutlineRectangleStack} size={48} iconProps={{ strokeWidth: 0.5 }} />
      <Text size="13px" c="#757575" mt="sm">
        No runs found
      </Text>
    </Center>
  );
};

export default RunPageEmpty;
